import React, { useEffect, useState, useRef, useCallback } from "react";
import Webcam from "react-webcam";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';

import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import UploadFileIcon from '@mui/icons-material/UploadFile';


import TextField from "@mui/material/TextField";
import { useForm } from "react-hook-form";

import Button from "@mui/material/Button";


const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } };
const FACING_MODE_USER = { facingMode: 'user' };

// const topics = [
//   { id: 1, name: 'รายการที่ 1', image: 'assets/aaa.png' },
//   // { id: 2, name: 'รายการที่ 2', image: 'assets/back_left.png' },
//   // { id: 3, name: 'รายการที่ 3', image: 'assets/back_right.png' },
//   // { id: 4, name: 'รายการที่ 4', image: 'assets/back.png' },
//   // { id: 5, name: 'รายการที่ 5', image: 'assets/engine.png' },
//   // { id: 6, name: 'รายการที่ 6', image: 'assets/front_console.png' },
//   // { id: 7, name: 'รายการที่ 7', image: 'assets/front_left.png' },
//   // { id: 8, name: 'รายการที่ 8', image: 'assets/front_right.png' },
//   // { id: 9, name: 'รายการที่ 9', image: 'assets/front.png' },
// ];



function CameraSuperSurvey(props) {
  const webcamRef = useRef(null);
  const [capturedImages, setCapturedImages] = useState(Array(9).fill(null));
  const [addedImages, setAddedImages] = useState([]);
  const [videoConstraints, setVideoConstraints] = useState(FACING_MODE_ENVIRONMENT);
  const [activeTopic, setActiveTopic] = useState(null);
  const [viewImage, setViewImage] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [cameraVisible, setCameraVisible] = useState(false);
  const [uploadAble, setUploadAble] = useState(false);  // true == can upload file

    const { register } = useForm({});

  useEffect(() => {
    // console.log("width",window.innerWidth);
    if(window.innerWidth>800){  // เช็คแบบง่ายๆ ไม่งั้นต้องไป 'npm install react-device-detect --save'
      setVideoConstraints(FACING_MODE_USER);
    }
    // console.log("props",props);
    // console.log("previousData",props.previousData);
    // setActiveTopic({ id: 1, displayFormat: 'B', name: 'ถ่ายรูปเลขไมล์' });
    // console.log("activeTopic",activeTopic);
    // setViewImage({ src: capturedImages[0], 0 });
    // console.log("viewImage",viewImage);
    // const imageSrc = webcamRef.current.getScreenshot();
    // console.log("webcamRef.current.getScreenshot",imageSrc);
      if(props.previousData){
        setCapturedImages(props.previousData);
      }
      // console.log("capturedImages",capturedImages);
        if(props.uploadAble){
          setUploadAble(props.uploadAble);
          // console.log("uploadAble", uploadAble);
        }
  }, []);

  const switchCamera = async () => {
    setVideoConstraints((prev) =>
      JSON.stringify(prev) === JSON.stringify(FACING_MODE_USER) ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER
    );
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      if (activeTopic !== null) {
        setCapturedImages((prev) => {
          const newImages = [...prev];
          newImages[activeTopic.id - 1] = imageSrc;
              // console.log("newImages",newImages);
              if(props.onCapture){
                props.onCapture(newImages);
              }
          return newImages;
        });
      } else if (isAddingNew) {
        // console.log("imageSrc on browse", imageSrc);
        setAddedImages((prev) => [...prev, imageSrc]);
      }
      // console.log("imageSrc",imageSrc);
      // console.log("props.items",props.items);

        // send img back to parent
        // props.onCapture(imageSrc);
        // console.log("capturedImages",capturedImages);
        // props.onCapture(capturedImages);
    }
    closeCamera();
  }, [activeTopic, isAddingNew]);

  const closeCamera = () => {
    setActiveTopic(null);
    setIsAddingNew(false);
    setCameraVisible(false);
  };

  const openCameraForTopic = (topic) => {
    setActiveTopic(topic);
    setIsAddingNew(false);
    setCameraVisible(true);
  };

  const openCameraForNewImage = () => {
    setActiveTopic(null);
    setIsAddingNew(true);
    setCameraVisible(true);
  };

  const handleImageUpload = (e) => {
    console.log("handleImageUpload");
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        console.log("base64",base64.substring(0, 40))
        if (activeTopic !== null) {
          setCapturedImages((prev) => {
            const newImages = [...prev];
            newImages[activeTopic.id - 1] = base64;
              if(props.onCapture){
                props.onCapture(newImages);
              }
            return newImages;
          });
        } else {
          setAddedImages((prev) => [...prev, base64]);
        }
        closeCamera();
      };
      reader.readAsDataURL(file);
    }
  };

  // const removeImage = (index) => {
  //   setCapturedImages((prev) => {
  //     const newImages = [...prev];
  //     newImages[index] = null;
  //     console.log("removeImage index",index);
  //       if(props.onRemoveImage){
  //         props.onRemoveImage(index, newImages);
  //       }
  //     return newImages;
  //   });
  //   setViewImage(null);
  // };

  const removeImage = (index, isFromAddedList = false) => {
    if (isFromAddedList) {
      setAddedImages((prev) => prev.filter((_, i) => i !== index));
    } else {
      setCapturedImages((prev) => {
        const newImages = [...prev];
        newImages[index] = null;
        // console.log("handleRemoveImage index", index, "newImages", newImages);
        if(props.onRemoveImage){
          props.onRemoveImage(index, newImages);
        }
        return newImages;
      });
    }
    setViewImage(null);
  };

  const c = "col-";
  const cameraWidth = props?props.itemsCol?c+props.itemsCol:"col-4":'';

  // const testgetimgsrc = () => {
  //   console.log("get capturedImages", capturedImages);
  //   console.log("props.previousData",props.previousData);
  // };

  // console.log("activeTopic",activeTopic);
  return (
    <div className="container text-center pt-3">
      {
        props?props.title?<h3>{props.title}</h3>
        :null:null
      }
      <div className="row">
        {props?props.items?props.items.map((topic, index) => (
          <div key={topic.id} className={cameraWidth + " p-2"}>
            <div className="border p-3 d-flex flex-column align-items-center">
              {capturedImages[index] ? (
                <img
                  src={capturedImages[index]}
                  alt={`Captured ${topic.name}`}
                  style={{ width: '100%', height: 'auto', cursor: 'pointer', objectFit: 'cover', maxWidth:'300px', maxHeight:'300px' }}
                  onClick={() => setViewImage({ src: capturedImages[index], index, isFromAddedList: false })}
                />
              ) : (
                <>
                  {
                    topic.displayFormat==='A'?<>
                    <span>{topic.name}</span>
                    <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={() => openCameraForTopic(topic)}>
                      +
                    </button></>
                    :null
                  }
                  {
                    topic.displayFormat==='B'?
                    <button type="button" className="btn btn-primary mt-2 text-nowrap" onClick={() => openCameraForTopic(topic)}>
                      <PhotoCameraIcon/> {topic.name}
                    </button>
                    :null
                  }
                </>
              )}
            </div>
          </div>
        ))
        :null:null
      }
      </div>


      {/* Modal camera */}
      {cameraVisible && (
        <div className="camera-container position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-dark">

          <Button color="primary" variant="outlined"
              aria-label="upload picture" component="label"
              sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
          >
              <input type="file" accept="image/*"
                  hidden capture onChange={handleImageUpload}
              />
            <div className="position-absolute bottom-0 mb-3 d-flex gap-3">
              <button type="button" className="btn btn-secondary" onClick={switchCamera}><CameraswitchIcon /></button>
              {uploadAble?
                <label htmlFor="upload-input" className="btn btn-secondary mb-0"><UploadFileIcon /></label>
              :null}
              <button type="button" className="btn btn-primary" onClick={capture}><PhotoCameraIcon /></button>
              <button type="button" className="btn btn-danger" onClick={closeCamera}>ปิด</button>
            </div>
          </Button>
        </div>
      )}


      {/* Modal to view image */}
      <Modal show={!!viewImage} onHide={() => setViewImage(null)} centered>
        <Modal.Body className="text-center">
          {viewImage && <img src={viewImage.src} alt="Captured" className="w-100" />}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={() => removeImage(viewImage.index, viewImage.isFromAddedList)}>ลบ</button>
          <button type="button" className="btn btn-secondary" onClick={() => setViewImage(null)}>ปิด</button>
        </Modal.Footer>
      </Modal>

                      {/*
                        props.previousData?
                        <img src={props.previousData.imageSrc} alt="Captured" className="w-100" />
                        :null
                      */}
            {/*<button type="button" className="btn btn-primary" onClick={testgetimgsrc}>testgetimgsrc</button>*/}


      {/* Button to add more images 
      <button type="button" className="btn btn-secondary mt-3" onClick={openCameraForNewImage}>Add More</button>
      */}

      {/* Display added images 
      <div className="mt-3">
        <h4>New Images</h4>
        <div className="row">
          {addedImages.map((img, index) => (
            <div key={index} className="col-4 p-2">
              <div className="border p-3 d-flex flex-column align-items-center">
                <img
                  src={img}
                  alt="Added Capture"
                  style={{ width: '100%', height: 'auto', cursor: 'pointer', objectFit: 'cover' }}
                  onClick={() => setViewImage({ src: img, index, isFromAddedList: true })}
                />
              </div>
            </div>
          ))}
        </div>
      </div> 
      */}


    </div>
  );
}

export default CameraSuperSurvey;
